var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowFlip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 96V416C0 451.348 28.654 480 64 480H448C483.346 480 512 451.348 512 416V96C512 60.652 483.346 32 448 32H64C28.654 32 0 60.652 0 96ZM256 128C256 145.75 241.75 160 224 160S192 145.75 192 128S206.25 96 224 96S256 110.25 256 128ZM352 128C352 145.75 337.75 160 320 160S288 145.75 288 128S302.25 96 320 96S352 110.25 352 128ZM448 128C448 145.75 433.75 160 416 160S384 145.75 384 128S398.25 96 416 96S448 110.25 448 128ZM48 224H464V416C464 424.824 456.822 432 448 432H64C55.178 432 48 424.824 48 416V224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowFlip);
export default __webpack_public_path__ + "static/media/window-flip.95cf4820bb5a1dccc6873ff56792ea21.svg";
export { ForwardRef as ReactComponent };